<template>
  <div class="monit_task_list">
    <el-table :data="tableList" height="488" border>
      <el-table-column
        v-for="(item, i) in tableItems"
        :key="i"
        show-overflow-tooltip
        :prop="item.prop" :label="item.label"
        :min-width="item.mw + 'px'"
        align="center">
        <template v-if="item.html" #default="{ row }"><div v-html="item.handle(row)"></div></template>
        <template v-else-if="item.handle" #default="{ row }">{{item.handle(row)}}</template>
        <template v-else #default="{ row }">{{row[item.prop]}}</template>
      </el-table-column>
      <el-table-column label="操作" min-width="120">
        <template #default="{ $index, row }">
          <div class="operate_btns">
            <el-popover popper-class="monit_task_popover" trigger="hover" placement="top-end">下载截图
              <template slot="reference"><i :class="['icon-xiazaijietu','iconfont', {'disable': downBtnDisable(row)}]" @click="downImg(row)"></i></template>
            </el-popover>
            <el-popover popper-class="monit_task_popover" trigger="hover" placement="top-end">下载失败列表
              <template slot="reference"><i :class="['icon-xiazaishibailiebiao','iconfont', {'disable': downFailBtnDisable(row)}]" @click="downFailList(row)"></i></template>
            </el-popover>
            <el-popover popper-class="monit_task_popover" trigger="hover" placement="top-end">删除任务
              <template slot="reference"><i :class="['icon-shanchu','iconfont', {'disable': delBtnDisable(row.oprStatus)}]" @click="deleteTask(row)"></i></template>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Confirm from './confirm'
import DelCf from './confirm/child/TaskDel.vue'
import { EvokeAdvClient } from '@/utils/config'
import { lastVersionAdvUtil } from '@/utils/api'

const protocolCheck = require('@/utils/protocolCheck')
const mode2name = { 0: '汇总', 1: '分城市' }

export default {
  name: 'MonitTaskList',
  props: {
    orderInfo: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      tableList: [],
      tableItems: [
        { prop: 'guid', label: '任务id', mw: 60 },
        { prop: 'taskName', label: '任务名称', mw: 158 },
        { prop: 'nbhdCount', label: '覆盖范围', mw: 150, handle: row => `共${row.nbhdCount || 0}个小区 ${row.screenCount || 0}个屏幕` },
        {
          prop: 'screen',
          label: '任务类型',
          mw: 136,
          handle: ({ screen, camera }) => {
            let taskType = ''
            if (camera === 1) taskType += '相机截图'
            if (screen === 1) taskType += taskType ? ',屏幕截图' : '屏幕截图'
            return taskType
          }
        },
        {
          prop: 'downloadMethod',
          label: '下载方式',
          mw: 80,
          handle: ({ downloadMethod }) => {
            return mode2name[downloadMethod] || '-'
          }
        },
        { prop: 'targetDate', label: '监播日期', mw: 100, },
        {
          html: true,
          prop: 'oprStatus',
          label: '完成情况',
          mw: 150,
          handle: row => {
            const oprStatus = row.oprStatus
            let str = `<span>成功<span class="sus">${row.succCount}</span>`
            if (oprStatus === 0) str += ` 等待<span>${row.allCount - row.succCount}</span></span>`
            if (oprStatus === 2) str += ` 失败<span class="fail">${row.failCount}</span></span>`
            let progressBar = `
              <div class="progress">
                <div class="ing" style="width: ${(row.succCount / row.allCount * 100).toFixed(2)}%"></div>
              </div>
            `;
            return `
              <div class="monit_task_list_status">
                <div>${str}</div>
                ${oprStatus === 0 ? progressBar : ''}
              </div>
            `
          }
        }
      ],
      toolObsUrl: '' // 广告桌面端应用obs下载链接
    }
  },
  computed: {
    cusId () {
      return this.$store.state.customer.userInfo.customerId
    }
  },
  created () {
    this.getAdvUtilLastVersion() // 获取最新版本下载工具的obs链接
    this.getTaskList()
  },
  methods: {
    async getAdvUtilLastVersion () {
      const platIdf = window.navigator.userAgentData.platform.toLowerCase() // 操作系统标识(windows | macos)
      const legacy = window.navigator.platform.toLowerCase() // 操作系统标识符(win32 | macintel)
      const platform = (platIdf === 'macos' || legacy === 'macintel') ? 'mac' : 'win32'
      const res = await lastVersionAdvUtil({ name: 'zladvutil', platform })
      if (res && res.code === 0) {
        this.toolObsUrl = res.data.url || ''
      } else {
        console.warn('获取广告工具obs下载链接失败:', res)
      }
    },
    getTimeLong (sec) {
      sec = sec - 0
      if (!sec) return '未知'
      let daySec = 60 * 60 * 24
      let day = Math.floor(sec / daySec)
      let hour = Math.floor(sec % daySec / 3600)
      let minute = Math.floor(sec % daySec % 3600 / 60)
      let str = (day > 0 ? day + '天' : '') + (hour > 0 ? hour + '小时' : '') + (minute > 0 ? minute + '分' : '')
      return str
    },
    downBtnDisable ({ oprStatus, succCount }) {
      // 待开始状态、其他状态下截图完成数为0 => 禁用下载按钮
      return (oprStatus === -1 || succCount <= 0)
    },
    downFailBtnDisable ({ oprStatus, failCount }) {
      if (oprStatus === -1 || oprStatus === 0) { // 待开始/进行中下载失败列表按钮不可用
        return true
      }
      if (oprStatus === 2 && failCount === 0)  { // 已完成但无失败结果，按钮不可用
        return true
      }
      return false
    },
    delBtnDisable (opr) {
      return opr !== 2 // 只有已完成的任务，删除按钮才可用
    },
    async getTaskList () {
      if (!this.cusId || !this.orderInfo.orderCode) {
        console.warn('客户ID/订单code为空，无法获取任务列表')
        return
      }
      const res = await this.fetch('/track/web/monitor/v2/taskList', {
        clienteleGuid: this.cusId,
        orderCode: this.orderInfo.orderCode
      }, 'get')
      if (res && res.code === 0) {
        let list = res.data || []
        this.tableList = list
        // 更新外部数量展示
        this.$emit(
          'changeTaskInfo',
          list.reduce(
            (data, cur) => {
              data.totalTask += 1
              if (cur.oprStatus === 2) data.finishTask += 1
              return data
            },
            { totalTask: 0, finishTask: 0 }
          )
        )
      }
    },
    downImg(row) {
      if (this.downBtnDisable(row)) return
      // const oc = this.orderInfo.orderCode
      // zlutil.loadTrackTask(row.guid, row.downloadMethod).then(taskInfo => {
      //   const zipName = `${oc}_${row.guid}_${row.taskName}`
      //   zlutil.downloadTrackPics(zipName, (progress) => {
      //     console.log(`download progress: ${100*progress}%`)
      //   }).then(() => {
      //     console.log('download complete')
      //   }).catch(e => {
      //     // console.warn('download fail', e)
      //     this.messageTip(e.message || '监播图下载失败，请稍后重试，或联系管理员')
      //   })
      // }).catch(err => {
      //   // console.warn('load task failed:', err)
      //   this.messageTip(err.message || '监播图下载失败，请稍后重试，或联系管理员')
      // })

      // 唤起下载工具，传参根据是否正式环境判断(测试环境需传profile=test)
      const protocol = EvokeAdvClient + row.guid + (window.location.host.startsWith('adv') ? '' : '?profile=test')
      const alink = document.createElement('a')
      alink.style.display = 'none'
      alink.href = protocol
      document.body.appendChild(alink)
      alink.addEventListener('click', (e) => {
        protocolCheck(protocol, () => { // 唤起失败
          // console.log('设备未安装下载工具')
          if (!this.toolObsUrl) console.warn('广告应用工具下载链接为空')
          this.$alert(`<p>您的设备未安装下载工具，请<a target="_blank" href="${this.toolObsUrl}" style="color:#FF3973;font-weight:600">安装工具</a>后再下载~</p>`, '提示', {
            confirmButtonText: '暂不下载',
            dangerouslyUseHTMLString: true,
            callback: act => {},
            center: true
          })
        }, () => {
          console.log('成功唤起')
        })
        document.body.removeChild(alink)
        e.preventDefault && e.preventDefault()
      })
      alink.click()
    },
    downFailList (row) {
      if (this.downFailBtnDisable(row)) return
      this.$exportGet('/track/web/monitor/v2/exportFailData', { taskGuid: row.guid, taskName: row.taskName })
    },
    deleteTask (row) {
      if (this.delBtnDisable(row.oprStatus)) return
      Confirm.init(
        'DelCf', DelCf, row,
        { title: '温馨提示', w: 400, h: 300, confirmBtnLabel: '确定', cancelBtnLabel: '再想想' }
      ).then( async _ => {
        let res = await this.fetch('/track/web/monitor/v2/deleteTaskByGuid?guid=' + row.guid, '', 'get')
        if (res && res.code === 0) {
          this.messageTip(res.msg || '操作成功', 1)
          this.getTaskList() // 任务删除成功，刷新表格
        } else {
          this.messageTip(res && res.msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-popover.monit_task_popover {
  min-width: auto;
}
.monit_task_list_status {
  font-weight: 600;
  padding: 0 10px;
  span {
    font-weight: 500;
    font-size: 12px;
    color: #999;
    &.sus {
      color: #282729;
      margin-right: 10px;
    }
    &.fail {
      color: #FF3973;
    }
  }
  .progress {
    height: 3px;
    background: #D4D4D4;
    border-radius: 3px;
    .ing {
      height: 100%;
      background: #FF3973;
      border-radius: 3px;
    }
  }
}
</style>
<style lang="scss" scoped>
.monit_task_list {
  background: #fff;
  height: 100%;
  padding: 20px 20px 0;
  position: relative;
  overflow: auto;
  ::v-deep .el-table {
    th, td {
      color: #282729;
      text-align: center;
    }
    thead {
      th {
        background: #f1f1f1;
        .cell {
          border-right: 1px solid rgba(40,39,41,0.12);
        }
      }
    }
    .el-table__cell .cell {
      padding: 0 6px;
    }
    i {
      cursor: pointer;
      font-size: 20px;
      outline: none;
      &.disabled {
        cursor: not-allowed;
      }
    }
  }
  .operate_btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
    ::v-deep .iconfont.disable {
      color: #D4D4D4;
      cursor: not-allowed;
    }
  }
}
</style>
